// Split out inbound and outbound for new filter sets work
export { default as OutboundReferralTable } from './OutboundReferralTable';
export { default as InboundReferralTable } from './InboundReferralTable';
